/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm } from '@insticator/insticator-ui'; // iui-utils

/* ++++++++++ --------------- EXPORT : COMMENT IMPORTER TOOL : STYLES --------------- ++++++++++ */
export default theme =>({
  commentimportertool: {
    '& .pageheader': { 
      maxWidth: '80em',
      alignItems: 'end',
      '& .name-docubtn': {
        height: pxToEm(40),
        fontSize: pxToEm(12),
        '& .icon': { fontSize: pxToEm(12) }
      }
    }
  }
});
